import { render, staticRenderFns } from "./TriggerEditor.vue?vue&type=template&id=ec96374a&scoped=true&"
import script from "./TriggerEditor.vue?vue&type=script&lang=js&"
export * from "./TriggerEditor.vue?vue&type=script&lang=js&"
import style0 from "./TriggerEditor.vue?vue&type=style&index=0&id=ec96374a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec96374a",
  null
  
)

export default component.exports